// Contrast Color Foundation
// This Color Palette consists of dark MainMenu
// and light content area

export default {
   globalNavLogoFieldName: 'logoDefaultNegative',
   listItemTitleTextColor: '#111',
   tmpBackgroundColor: '#fff',
   tmpBodyTextColor: '#666',
   tmpFooterBackgroundColor: '#eee',
   // Main Menu
   tmpMainMenuBackgroundColor: '#000',
   tmpMainMenuBorderColor: '#111',
   tmpMainMenuButtonTextColor: '#777',
   tmpMainMenuButtonActiveTextColor: '#fff',
   tmpMainMenuButtonActiveBackgroundColor: '#111',
   tmpMainMenuLineColor: 'rgba(255,255,255,0.07)',
   tmpMainMenuSearchBackgroundColor: 'rgba(255,255,255,0.05)',
   tmpMainMenuTextColor: 'rgba(255,255,255,0.4)',
   tmpMainMenuTitleColor: '#fff',
   // Aside
   tmpAsideBodyTextColor: '#777',
   tmpAsideButtonTextColor: '#666',
   tmpAsideButtonActiveTextColor: '#111',
   tmpAsideButtonActiveBackgroundColor: '#e5e5e5',
   tmpAsideLineColor: '#e5e5e5',
   tmpAsideTitleColor: '#333',
   // Content
   tmpContentBackgroundColor: '#fff',
   tmpContentLineColor: '#eee',
   tmpContentTitleColor: '#333',
   // Will change
   tmpBorderColor: '#111',
   tmpColumnBorderColor: '#eee'
}
